import { Box } from '@branch-messenger/willow-ui'
import styled, { keyframes } from 'styled-components'

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`

export const Skeleton = styled(Box).attrs({
  $fullWidth: true,
})<{
  $height?: number
  $width?: number
}>`
  height: ${({ $height }) => ($height ? `${$height}px` : 'inherit')};
  width: ${({ $width }) => ($width ? `${$width}px` : 'inherit')};
  animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  background-color: ${({ theme }) => theme.colors.gray};
  border-radius: ${({ theme }) => theme.radii.md};
`
